import jsPDF from 'jspdf';
import config from "../common/Config";
import { axiosFetchProformaInvoice } from '../../utils/proformaInvoiceApi';

const printPaymentReceipt = async (orderId, paymentDetails, grandTotal, paidAmt) => {
  const accessToken = localStorage.getItem('accessToken');
  const token = localStorage.getItem('token');

  let customerDetails = {};
 let shopDetails = {};
  try {
    const data = await axiosFetchProformaInvoice(orderId, token);
    if (data && data.success && data.details && data.details.orderDetails) {
      customerDetails = data.details.orderDetails[0];
      shopDetails = data.details.shop_details;
      console.log('Shop details:', shopDetails);
    }
  } catch (error) {
    console.error('Error fetching customer details:', error);
  }

  const doc = new jsPDF('portrait'); // Set to portrait orientation
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const margin = 8;   // Set margin to 8px 
  let y = margin; // Initial vertical position

  // Center aligned text
  const centerAlign = (text, fontSize = 12, bold = false) => {
    doc.setFontSize(fontSize);
    doc.setFont('helvetica', bold ? 'bold' : 'normal');
    const textWidth = doc.getStringUnitWidth(text) * fontSize / doc.internal.scaleFactor;
    const x = (pageWidth - textWidth) / 2;
    doc.text(text, x, y);
    y += fontSize + 2;
  };

  // Left aligned label + value
  const leftLabelValue = (label, value, fontSize = 11) => {
    doc.setFontSize(fontSize);
    doc.setFont('helvetica', 'normal');
    doc.text(`${label}: ${value}`, margin, y);
    y += fontSize + 2;
  };

  // Get user details from localStorage
  const userId = localStorage.getItem('userId');
  const firstName = localStorage.getItem('first_name') || '';
  const lastName = localStorage.getItem('lastName') || '';
  console.log('firstName:', firstName);

  // Define logo dimensions
  const logoWidth = 40; // Width of the logo in the PDF
  const logoHeight = 20; // Height of the logo

  const logoUrl = `${config.BASE_URL}/assets/img/${accessToken}_logo.png`;

  let detailsX = margin + logoWidth + 10;
  let detailsY = y;
  console.log('shopDetails:', shopDetails.shop_name);
  if (shopDetails && shopDetails.shop_name) {
    doc.setFontSize(13);
    doc.setFont('helvetica', 'bold');
    doc.text(shopDetails.shop_name, detailsX, detailsY + 5);
    detailsY += 9;

    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');

    if (shopDetails.address) {
      doc.text(shopDetails.address, detailsX, detailsY);
      detailsY += 4;
    }

    if (shopDetails.phone || shopDetails.email) {
      doc.text(`Phone No : ${shopDetails.phone || ''} | Email : ${shopDetails.email || ''}`, detailsX, detailsY);
      detailsY += 4;
    }
    if (shopDetails.bank_ac || shopDetails.sort_code) {
      doc.text(`Bank A/C : ${shopDetails.bank_ac || ''} | Sort Code : ${shopDetails.sort_code || ''}`, detailsX, detailsY);
      detailsY += 4;
    }

    if (shopDetails.website) {
      doc.text(`VAT No : ${shopDetails.vat_no || ''} |  Website : ${shopDetails.website}`, detailsX, detailsY);

      detailsY += 1;
    }

    if (shopDetails.logo) {
      try {
        const cleanLogoUrl = shopDetails.logo.replace(/`/g, '').trim();
        doc.addImage(cleanLogoUrl, 'PNG', margin, y, logoWidth, logoHeight);
      } catch (error) {
        console.error('Error adding logo from company details:', error);
        try {
          doc.addImage(logoUrl, 'PNG', margin, y, logoWidth, logoHeight);
        } catch (logoError) {
          console.error('Error adding default logo:', logoError);
        }
      }
    }
  } else {

    const siteName = localStorage.getItem('siteName') || 'Receipt';
    doc.setFontSize(13);
    doc.setFont('helvetica', 'bold');
    doc.text(siteName, detailsX, detailsY + 5);
  }

  y = Math.max(y + logoHeight + 5, detailsY + 5);

  doc.setLineWidth(0.5);
  doc.line(margin, y, pageWidth - margin, y);
  y += 5;

  const leftColumn = margin;
  const rightColumn = pageWidth / 2 + 10;

  doc.setFontSize(11);
  doc.setFont('helvetica', 'normal');

  let custY = y;
  if (customerDetails && Object.keys(customerDetails).length > 0) {
    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.text('CUSTOMER', leftColumn, custY);
    custY += 6;

    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');

    if (customerDetails.company) {
      doc.text(`Name: ${customerDetails.company}`, leftColumn, custY);
      custY += 5;
    } else if (customerDetails.name) {
      doc.text(`Name: ${customerDetails.name}`, leftColumn, custY);
      custY += 5;
    }

    if (customerDetails.address) {
      doc.text(`Address: ${customerDetails.address}`, leftColumn, custY);
      custY += 5;

      if (customerDetails.city || customerDetails.postal_code) {
        const cityPostal = [customerDetails.city, customerDetails.postal_code].filter(Boolean).join(', ');
        doc.text(cityPostal, leftColumn + 20, custY);
        custY += 5;
      }
    }

    if (customerDetails.phone) {
      doc.text(`Phone: ${customerDetails.phone}`, leftColumn, custY);
      custY += 5;
    }

    if (customerDetails.email) {
      doc.text(`Email: ${customerDetails.email}`, leftColumn, custY);
      custY += 5;
    }
  }

  let orderY = y;
  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.text('ORDER', rightColumn, orderY);
  orderY += 6;

  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text(`Order ID: ${customerDetails.reference_no}`, rightColumn, orderY);

  orderY += 5;
  doc.text(`Cashier: ${firstName} ${lastName}`.trim(), rightColumn, orderY);
  orderY += 5;

  const currentDate = new Date();
  const day = String(currentDate.getDate()).padStart(2, '0');
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const year = String(currentDate.getFullYear());
  const formattedDate = `${day}-${month}-${year}`;

  // Format time: hh:mm AM/PM
  let hours = currentDate.getHours();
  const minutes = String(currentDate.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12; // convert 0 → 12
  const formattedTime = `${hours}:${minutes} ${ampm}`;

  doc.text(`Date: ${formattedDate}`, rightColumn, orderY);
  orderY += 5;
  doc.text(`Time: ${formattedTime}`, rightColumn, orderY);
  orderY += 5;

  // Move y down based on the taller column
  y += Math.max(custY - y, orderY - y) + 5;

  // Horizontal line after both
  doc.setLineWidth(0.5);
  doc.line(margin, y, pageWidth - margin, y);
  y += 5;

  // Payment Details Title
  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  const paymentTitle = 'PAYMENT RECEIPT';

  const paymentTitleWidth = doc.getStringUnitWidth(paymentTitle) * 14 / doc.internal.scaleFactor;
  doc.text(paymentTitle, (pageWidth - paymentTitleWidth) / 2, y);
  y += 10;

  // Payment Methods Table
  if (paymentDetails && paymentDetails.length > 0) {
    // Table headers
    const tableStartY = y;
    const methodCol = margin;
    const detailsCol = margin + 60;
    const amountCol = pageWidth - margin - 30;

    // Draw table header
    doc.setFillColor(240, 240, 240); // Light gray background
    doc.rect(margin, y - 5, pageWidth - (margin * 2), 8, 'F');

    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.text('Payment Method', methodCol, y);
    doc.text('Details', detailsCol, y);
    // Right align the Amount header
    const amountHeader = 'Amount';
    doc.text(amountHeader, amountCol - doc.getStringUnitWidth(amountHeader) * 11 / doc.internal.scaleFactor, y);
    y += 8;

    // Table rows
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    
    // Consolidate payments by method
    const consolidatedPayments = {};
    
    paymentDetails.forEach(payment => {
      const method = payment.method.toLowerCase();
      if (!consolidatedPayments[method]) {
        consolidatedPayments[method] = {
          method: payment.method,
          amount: 0,
          details: []
        };
      }
      
      consolidatedPayments[method].amount += parseFloat(payment.amount);
      
      // Add payment details if available
      if (method === 'cheque' && payment.chequeNo) {
        let detail = `Cheque #: ${payment.chequeNo}`;
        if (payment.chequeDate) {
          detail += ` | Date: ${payment.chequeDate}`;
        }
        consolidatedPayments[method].details.push(detail);
      } else if (method === 'card' && payment.cardNumber) {
        consolidatedPayments[method].details.push(`Trans ID: ${payment.cardNumber}`);
      }
    });
    
    // Display consolidated payments
    Object.values(consolidatedPayments).forEach((payment, index) => {
      const method = payment.method.charAt(0).toUpperCase() + payment.method.slice(1);
      const amount = payment.amount.toFixed(2);
      
      // Row background (alternate colors)
      if (index % 2 === 1) {
        doc.setFillColor(248, 248, 248);
        doc.rect(margin, y - 4, pageWidth - (margin * 2), 8, 'F');
      }
      
      doc.text(method, methodCol, y);
      
      // Display payment details or default
      let details = payment.details.length > 0 ? payment.details[0] : '-';
      doc.text(details, detailsCol, y);
      
      // Right align the amount
      const amountText = `${amount}`;
      doc.text(amountText, amountCol - doc.getStringUnitWidth(amountText) * 10 / doc.internal.scaleFactor, y);
      y += 4;
    });

  } else {
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.text('No payment details available', margin, y);
    y += 8;
  }

  // Horizontal Line
  y += 5;
  doc.setLineWidth(0.5);
  doc.line(margin, y, pageWidth - margin, y);
  y += 8;

  // Totals - Summary Box
  const summaryBoxWidth = 70;
  const summaryBoxHeight = 40;
  const summaryBoxX = pageWidth - margin - summaryBoxWidth;
  const summaryBoxY = y;

  // Draw summary box with light background
  doc.setFillColor(248, 248, 248);
  doc.rect(summaryBoxX, summaryBoxY, summaryBoxWidth, summaryBoxHeight, 'F');
  doc.setDrawColor(200, 200, 200);
  doc.setLineWidth(0.3);
  doc.rect(summaryBoxX, summaryBoxY, summaryBoxWidth, summaryBoxHeight, 'S');

  // Summary title
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text('SUMMARY', summaryBoxX + 5, summaryBoxY + 8);

  // Summary content
  const labelX = summaryBoxX + 5;
  const valueX = summaryBoxX + summaryBoxWidth - 5;
  let summaryY = summaryBoxY + 18;

  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');

  // Invoice Total
  doc.text('Invoice Total:', labelX, summaryY);
  const totalText = `${parseFloat(grandTotal).toFixed(2)}`;
  doc.text(totalText, valueX - doc.getStringUnitWidth(totalText) * 10 / doc.internal.scaleFactor, summaryY);
  summaryY += 10;

  // Amount Paid
  doc.text('Amount Paid:', labelX, summaryY);
  const paidText = `${parseFloat(paidAmt).toFixed(2)}`;
  doc.text(paidText, valueX - doc.getStringUnitWidth(paidText) * 10 / doc.internal.scaleFactor, summaryY);
  summaryY += 10;

  const balanceDue = Math.max(0, parseFloat(grandTotal) - parseFloat(paidAmt));
  const balance = balanceDue.toFixed(2);
  doc.setFont('helvetica', 'bold');
  doc.text('Balance:', labelX, summaryY);
  const balanceText = `${balance}`;
  doc.text(balanceText, valueX - doc.getStringUnitWidth(balanceText) * 10 / doc.internal.scaleFactor, summaryY);

  y = summaryBoxY + summaryBoxHeight + 10;

  // Footer
  // Add a line above footer
  doc.setLineWidth(0.5);
  doc.line(margin, pageHeight - 30, pageWidth - margin, pageHeight - 30);

  // Footer text
  y = pageHeight - 25;
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  const footerText = 'Thank you for your payment!';
  const footerWidth = doc.getStringUnitWidth(footerText) * 10 / doc.internal.scaleFactor;
  doc.text(footerText, (pageWidth - footerWidth) / 2, y);

  y += 5;
  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  const dateText = `Receipt generated on ${formattedDate},${formattedTime}`;
  const dateWidth = doc.getStringUnitWidth(dateText) * 8 / doc.internal.scaleFactor;
  doc.text(dateText, (pageWidth - dateWidth) / 2, y);

  const filename = `Payment_Receipt_${orderId}.pdf`;
  doc.autoPrint();
  window.open(doc.output('bloburl'));
  //doc.save(filename);
};

export default printPaymentReceipt;